import { Center, Modal, Stack, Title, Text, Flex, Divider, Anchor, LoadingOverlay, Box } from '@mantine/core';
import { DocumentToApprove, DocumentsToApprove } from 'models/general';
import { useApproveDocument } from 'services/configuration';
import { Trans, useTranslation } from 'react-i18next';
import { PortalButton } from 'components/Button/PortalButton';
import { PickEnForAmericanEnglish } from 'utils/i18n';

interface Props {
  userId: string;
  document: DocumentToApprove;
}

export const ApproveDocumentsModal = ({ userId, document }: Props) => {
  const { t } = useTranslation();
  const { mutate: approveDocument, isPending } = useApproveDocument();

  return (
    <Modal opened={true} centered size={'lg'} withCloseButton={false} onClose={function onClose(): void {}}>
      <Center>
        <Stack>
          <Flex direction={'column'} align={'center'}>
            <Title order={2} mb={0}>
              {t(`${document.key}_label`)}
            </Title>
            <Text>{document.version}</Text>
          </Flex>
          <Divider />
          <Box pos={'relative'}>
            <LoadingOverlay visible={isPending} overlayProps={{ blur: 0.3 }} loaderProps={{ size: 'lg' }} />
            <Text ta={'center'} size={'sm'}>
              <Trans
                i18nKey={document.isNew ? 'dta_new_label' : 'dta_updated_label'}
                components={[
                  <Anchor
                    key={'dta_link'}
                    target={'_blank'}
                    href={`${document.url}${PickEnForAmericanEnglish().toLowerCase()}`}
                  />,
                ]}
                values={{
                  value: t(`${document.key}_label`),
                }}
              />
            </Text>
            {document.key === DocumentsToApprove.medicalProfessionalAgreement && document.isNew && (
              <Text ta={'center'} size={'sm'} fw={'bold'} mt={10}>
                {t('dta_extra_text')}
              </Text>
            )}
          </Box>
          <Divider my={'sm'} />
          <PortalButton
            disabled={isPending}
            onClick={() => approveDocument({ userId, document })}
            label={t(`accept_label`)}
          />
        </Stack>
      </Center>
    </Modal>
  );
};
